import { LOGOUT } from "@/components/access/ducks/Actions"
import {
  RECEIVE_IP_ADDRESSES,
  RECEIVE_WAVELENGTH_EMPLOYEES,
} from "@/components/permissions/internal/ducks/Actions"

const defaultState = {
  wavelengthEmployees: [],
  allowedIPs: [],
  allowedIPsFetched: false,
  wavelengthEmployeesFetched: false,
}

const internalPermissionsReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_WAVELENGTH_EMPLOYEES:
      return {
        ...oldState,
        wavelengthEmployees: action.response.wavelengthEmployees,
        wavelengthEmployeesFetched: true,
      }
    case RECEIVE_IP_ADDRESSES:
      return {
        ...oldState,
        allowedIPs: action.response.allowedIPs,
        allowedIPsFetched: true,
      }

    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default internalPermissionsReducer
